import React, { useContext } from 'react'
import { PermissionsContext } from '../context'

export const usePermissions = () => {
  const { hasPermission, user } = useContext(PermissionsContext)
  return { hasPermission, user }
}
